import { useGetUserFullNameWithFallback } from '@pba/react-utils';
import type { UserDetail } from 'models';
import type { ReactNode } from 'react';
import { Avatar, Card, Col, Row, Space, Text, Title } from 'ui';
import { ReadMoreText } from '../read-more-text';

type P = {
  actions: ReactNode;
  member: UserDetail;
};

const MemberProfileCard = ({ actions, member }: P) => {
  const { biography, email, profilePhoto } = member;
  const fullName = useGetUserFullNameWithFallback();

  return (
    <Card>
      <Row gutter={[0, 'lg']}>
        <Col justifyContent="center" span={24}>
          <Avatar size="xxxl" src={profilePhoto} />
        </Col>
        <Col span={24}>
          <Space align="center" block orientation="vertical" size="xxs">
            <Title level={1}>{fullName(member)}</Title>
            <Text>{email}</Text>
          </Space>
        </Col>

        {biography ? (
          <Col span={24}>
            <ReadMoreText description={biography} />
          </Col>
        ) : null}

        <Col span={24}>{actions}</Col>
      </Row>
    </Card>
  );
};

export default MemberProfileCard;
